import { IonButton, IonInput, IonItem, IonLabel, IonSpinner } from "@ionic/react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import InputErrorMessage from "../../../components/InputErrorMessage";
import { createTemplate } from "../../../store/templateCreate/actions/createTemplate";
import { selectCreateTemplateStatus } from "../../../store/templateCreate/selectors/selectCreateTemplateStatus";
import {useMemo} from "react";

export const TemplateCreateForm: React.FC = () => {
  const createStatus = useSelector(selectCreateTemplateStatus);
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const onSubmit = async (data: { name: string }) => {
    try {
      const { payload }: any = await dispatch(createTemplate(data.name));
      return history.replace(`/app/tic/plantillas/detalle/${payload.id}`);
    } catch (error) {
      console.log(error);
    }
  };

  const controllers = useMemo(()=>{
    return [({ field: { onChange, value } }:any) => (
      <IonInput
        onIonChange={(e) => onChange(e.detail.value)}
        value={value}
        {...register("name", {
          required: "Campo obligatorio.",
        })}
      />
    )]
  },[])

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <IonItem>
        <IonLabel position="stacked">Nombre de la plantilla</IonLabel>
        <Controller
          control={control}
          name="name"
          render={controllers[0]}
        />
      </IonItem>
      {errors.name && (
        <>
          <InputErrorMessage errorMessage={errors.name?.message || ""} paddingLeft={15} /> <br />
        </>
      )}
      <IonButton type="submit" disabled={createStatus === "pending"}>
        {createStatus === "pending" ? (
          <>
            <IonSpinner /> Creando plantilla...
          </>
        ) : (
          "Crear plantilla"
        )}
      </IonButton>
    </form>
  );
};
